module.exports = __webpack_public_path__ + "img/11.3a76f964.png";